<app-window-title
  title="Facility Setup"
  [closable]="true"
  (closed)="onClose()">
</app-window-title>

<div class="facility-setup-content">
  <p
    *ngIf="facilityName"
    class="facility-name-label">
    <strong>Facility:</strong> {{ facilityName }}
  </p>

  <mat-form-field
    class="full-width-field"
    appearance="outline">
    <mat-label>PACS URL</mat-label>
    <input
      matInput
      type="url"
      [formControl]="pacsUrlControl"
      [readonly]="loading" />
    <mat-progress-spinner
      *ngIf="loading"
      matSuffix
      diameter="20"></mat-progress-spinner>
    <mat-hint>Optional. URL of the PACS / Orthanc server for this facility. Leave empty if not used.</mat-hint>
    <mat-error *ngIf="pacsUrlControl.hasError('invalidUrl')">
      Please enter a well-formatted URL (e.g. https://example.com).
    </mat-error>
  </mat-form-field>

  <mat-form-field
    class="full-width-field"
    appearance="outline">
    <mat-label>Email Domain</mat-label>
    <input
      matInput
      type="text"
      [formControl]="emailDomainControl"
      [readonly]="loading" />
    <mat-hint>Required for user creation. Allowed email domain for facility users (e.g. hospital.org).</mat-hint>
    <mat-error *ngIf="emailDomainControl.hasError('invalidDomain')">
      Please enter a valid domain (e.g. example.com).
    </mat-error>
  </mat-form-field>

  <!-- Facility Timezone — used to compute business-safe study expiration -->
  <mat-form-field
    class="full-width-field"
    appearance="outline">
    <mat-label>Facility Timezone</mat-label>
    <mat-select
      [formControl]="timezoneControl"
      [disabled]="loading">
      <mat-option
        *ngFor="let tz of timezoneOptions"
        [value]="tz.value">
        {{ tz.label }}
      </mat-option>
    </mat-select>
    <mat-hint>Used to ensure shared studies expire during business hours in this facility's local time.</mat-hint>
    <mat-error *ngIf="timezoneControl.hasError('required')">
      Please select a timezone.
    </mat-error>
  </mat-form-field>

  <!-- C-MOVE quota meter — Hub users only -->
  <div *ngIf="isHubUser && quotaOwnerID" class="quota-section">
    <app-cmove-quota-bar [ownerID]="quotaOwnerID"></app-cmove-quota-bar>
    <a class="usage-link" (click)="navigateToUsage()">View full usage dashboard →</a>
  </div>

  <div class="button-container">
    <button
      mat-button
      (click)="onClose()"
      [disabled]="saving">
      Cancel
    </button>
    <button
      mat-flat-button
      color="warn"
      (click)="onSave()"
      [disabled]="loading || saving">
      <mat-progress-spinner
        *ngIf="saving"
        diameter="20"
        style="display: inline-block; margin-right: 8px; vertical-align: middle"></mat-progress-spinner>
      {{ saving ? 'Saving...' : 'Save' }}
    </button>
  </div>
</div>
